import { render, staticRenderFns } from "./importantDocuments.vue?vue&type=template&id=8e25a860&scoped=true"
import script from "./importantDocuments.vue?vue&type=script&lang=js"
export * from "./importantDocuments.vue?vue&type=script&lang=js"
import style0 from "./importantDocuments.vue?vue&type=style&index=0&id=8e25a860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e25a860",
  null
  
)

export default component.exports